import React from 'react';
import { Search } from 'lucide-react';
import PageHero from '../components/common/PageHero';
import GraduateSearch from '../components/search/GraduateSearch';

const SearchPage = () => (
  <div className="bg-ink-50">
    <PageHero
      icon={Search}
      title="Search graduation records"
      subtitle="Enter your admission number or telephone number to verify your graduation status"
    />
    <GraduateSearch />
  </div>
);

export default SearchPage;
